import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {path: '/inbox', component: () => import('./views/Inbox')},
        {
            path: '/setting',
            component: () => import('./views/setting/Setting'),
            children: [
                {path: '', redirect: '/setting/profile'},
                {path: 'profile', component: () => import('./views/setting/account-info/Profile')},
                {path: 'google-sheet', component: () => import('./views/setting/integration/google-sheet/List')},
                {path: 'group', component: () => import('./views/setting/roles-and-users/Group')},
                {path: 'user-account', component: () => import('./views/setting/roles-and-users/UserAccount')},
                {path: 'roles', component: () => import('./views/setting/roles-and-users/Roles')},
                {path: 'device-token', component: () => import('./views/setting/account-info/DeviceToken')},
                {path: 'other-device', component: () => import('./views/setting/account-info/SignInOtherDevice')},
                {path: 'custom-field', component: () => import('./views/setting/custom-info/CustomFields')},
                {path: 'custom-status', component: () => import('./views/setting/custom-info/CustomStatuses')},
                {path: 'phone', component: () => import('./views/setting/communication/phone/Phone')},
                {path: 'email', component: () => import('./views/setting/communication/email/Email')},
                {path: 'sms', component: () => import('./views/setting/communication/sms/SMSBrandName')},
                {
                    path: 'social-network-account',
                    component: () => import('./views/setting/communication/social-network/List')
                },
                {path: 'zns', component: () => import('./views/setting/communication/zns/ZNSTemplate')},
                {
                    path: 'black-list-contact',
                    component: () => import('./views/setting/communication/black-list-contact/BlackListContact')
                },
                {path: 'token', component: () => import('./views/setting/integration/Token')},
                {path: 'web-hook', component: () => import('./views/setting/integration/WebHook')},
                {
                    path: 'automation-triggered',
                    component: () => import('./views/setting/automation/AutomationTriggered')
                },
            ]
        },
        {path: '/login', component: () => import('./views/auth/Login')},
        {path: '/register', component: () => import('./views/auth/Register')},
        {path: '/forgot', component: () => import('./views/auth/Forgot')},
        {path: '/reset/:token', component: () => import('./views/auth/Reset'), props: true},
        {path: '/use/:token', component: () => import('./views/UseUser'), props: true},
        {path: '/report', component: () => import('./views/report/Report')},
        {path: '/report/call', component: () => import('./views/report/Call')},
        {path: '/report/audio-quality', component: () => import('./views/report/AudioQuality')},
        {path: '/report/patient', component: () => import('./views/report/Patient')},
        {
            path: '/history', component: () => import('./views/history/History'), children: [
                {path: '', redirect: '/history/call'},
                {path: 'call', component: () => import('./views/history/CallHistory')},
            ]
        },
        {path: '/contact', redirect: '/contact/benh-nhan'},
        {path: '/contact/benh-nhan', component: () => import('./views/benh-nhan/BenhNhan'), props: true},
        {path: '/contact/internal', component: () => import('./views/InternalContact'), props: true},
        {path: '/contact/nhom-nvyt', component: () => import('./views/nhom-nvyt/NhomNVYT'), props: true},
        {path: '/issue', component: () => import('./views/1022/Issue'), props: true},
        {path: '/support', component: () => import('./views/Support')},
        {path: '*', redirect: '/inbox'},
        {path: '/', redirect: '/inbox'}
    ],
})